var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "#2B2B35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.27499H10.5067",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 3.60837H5.16675C4.06218 3.60837 3.16675 4.5038 3.16675 5.60837V12.275C3.16675 13.3796 4.06218 14.275 5.16675 14.275H11.8334C12.938 14.275 13.8334 13.3796 13.8334 12.275V5.60837C13.8334 4.5038 12.938 3.60837 11.8334 3.60837Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16675 10.9416L5.83341 8.27498C6.13745 7.98242 6.48234 7.8284 6.83341 7.8284C7.18449 7.8284 7.52938 7.98242 7.83341 8.27498L11.1667 11.6083",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 10.2751L10.4999 9.60839C10.804 9.31583 11.1488 9.1618 11.4999 9.1618C11.851 9.1618 12.1959 9.31583 12.4999 9.60839L13.8333 10.9417",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuImage);
export default __webpack_public_path__ + "static/media/a11ymenu_image.5a82cc518ed5ea955306a71ffc11089f.svg";
export { ForwardRef as ReactComponent };